module.exports = __webpack_public_path__ + "img/anli_default.5b4fa81.png";